export default {
    workOrder_historyLogs_createdOn: "Creado En",
    workOrder_historyLogs_updatedOn: "Actualizado En",
    workOrder_historyLogs_scheduledDate: "Fecha de Programación",
    workOrder_historyLogs_customer: "Cliente",
    workOrder_historyLogs_location: "Ubicación",
    workOrder_historyLogs_contact: "Contacto",
    workOrder_historyLogs_driver: "Conductor",
    workOrder_historyLogs_estimatedDuration: "Duración Estimada",
    workOrder_historyLogs_severity: "Severidad",
    workOrder_historyLogs_status: "Estado",
    workOrder_historyLogs_description: "Descripción",
    workOrder_historyLogs_changeStatus: "Estado Modificado",
    workOrder_historyLogs_createWorkOrder: "Orden de Trabajo Creada",
    workOrder_historyLogs_updateWorkOrder: "Orden de Trabajo Editada",
    workOrder_historyLogs_createComment: "Comentario creado",
    workOrder_historyLogs_updateComment: "Comentario Editada",
    workOrder_historyLogs_deleteComment: "Comentario Eliminado",
    workOrder_historyLogs_comment: "Comentario",
    workOrder_historyLogs_type: "Tipo",
    workOrder_historyLogs_action: "Acción",
    workOrder_historyLogs_arrival: "El conductor llegó al lugar",
    workOrder_historyLogs_departure: "El conductor salio al lugar",
    workOrder_historyLogs_address: "Dirección",
    workOrder_historyLogs_gpsEvent: "Evento GPS",
    workOrder_historyLogs_locationName: "Nombre de la Ubicación",
    workOrder_historyLogs_customerName: "Nombre del Cliente",
    workOrder_historyLogs_createdBy: "Creado Por",
    workOrder_historyLogs_contactName: "Nombre del Contacto",
    workOrder_historyLogs_contactEmail: "Correo del Contacto",
    workOrder_historyLogs_contactPhone: "Teléfono del Contacto",
    workOrder_historyLogs_address: "Dirección",
    workOrder_historyLogs_previousStatus: "Estado Anterior",
    workOrder_historyLogs_newStatus: "Nuevo Estado",
    workOrder_historyLogs_changes: "Cambios",
    workOrder_historyLogs_note: "Nota",
    workOrder_historyLogs_completedForm: "Formulario Completado",
    workOrder_historyLogs_updatedForm: "Formulario Actualizado",
};